import type { SiteBrand } from '~/config/branding';
import { paths } from '~/routing/routes';

interface SiteNavItem {
  name: string;
  href: string;
}

/**
 * The public site's top-nav tabs, as PublicHeader lists them. The /features page still exists but
 * is no longer a tab (Dr West, MCV-1880/1881 QA 2026-10-26).
 */
export const SITE_NAV_ITEMS: readonly SiteNavItem[] = [
  { name: 'For Organizations', href: '/organizations' },
  { name: 'For Providers', href: '/providers' },
  { name: 'FAQ', href: '/faq' },
  { name: 'Security', href: '/security' },
  { name: 'Contact', href: '/contact' },
  { name: 'About', href: '/about' },
];

/**
 * Where the signed-in header's ? opens the same knowledge base inside the app, one route per brand
 * shell. The page is the same as /faq, only its address differs; its section ids stay the stable
 * `/faq#<id>` contract (see scripts/README.md). [MCV-1724]
 */
const IN_APP_FAQ_PATH: Record<SiteBrand, string> = {
  mcv: paths.vault.faq,
  hlx: paths.hlx.faq,
};

/**
 * The in-app FAQ for this brand. The header ? opens it at the top, the same for every role
 * (MCV-1724, QA 2026-10-05).
 */
export const inAppFaqHref = (brand: SiteBrand): string => IN_APP_FAQ_PATH[brand];
